import loadable from '@loadable/component';

export const MusicradarSiteWrapper = loadable(
  () => import(/* webpackChunkName: "musicradar-site" */ './MusicradarSiteWrapper'),
);
